<template>
  <div class="flex flex-col gap-6">
    <SettingsCard
      title="Gerenciar credenciais"
      description="Use credenciais fortes com ao menos 8 caracteres, incluindo letras e números."
    >
      <form class="flex flex-col gap-4" @submit.prevent="handleSubmit">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-1">
          <GenericInput
            v-model="form.currentPassword"
            label="Credencial atual"
            type="password"
            required
            data-testid="security-current-password-input"
            :error-messages="errors.currentPassword"
          />
          <GenericInput
            v-model="form.password"
            label="Nova credencial"
            type="password"
            required
            data-testid="security-new-password-input"
            :error-messages="errors.password"
          />
          <GenericInput
            v-model="form.repeatPassword"
            label="Confirmar nova credencial"
            type="password"
            required
            data-testid="security-repeat-password-input"
            :error-messages="errors.repeatPassword"
          />
        </div>

        <div class="flex justify-end pt-2">
          <FilledButton
            text="Atualizar credenciais"
            width="180px"
            type="submit"
            :loading="saving"
            data-testid="security-save-button"
          />
        </div>
      </form>
    </SettingsCard>

    <!-- <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <ComingSoonCard
        :icon="mdiShieldCheckOutline"
        title="Autenticação em dois fatores (2FA)"
        description="Adicione uma camada extra de segurança exigindo um código além das credenciais ao entrar."
        test-id="security-2fa-coming-soon"
      />
      <ComingSoonCard
        :icon="mdiLaptop"
        title="Sessões ativas"
        description="Veja e encerre os dispositivos conectados à sua conta."
        test-id="security-sessions-coming-soon"
      />
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'
import { ValidationError } from 'yup'
// import { mdiShieldCheckOutline, mdiLaptop } from '@mdi/js'

import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

import SettingsCard from '../atoms/SettingsCard.vue'
// import ComingSoonCard from '../atoms/ComingSoonCard.vue'
import { passwordSchema } from '../../schemas'

const props = defineProps<{
  // Handler assíncrono: deve resolver em sucesso e rejeitar em erro (o pai exibe o toast).
  save: (payload: { password: string; repeatPassword: string }) => Promise<void>
}>()

const saving = ref(false)
const errors = reactive<Record<string, string>>({})

const form = reactive({
  currentPassword: '',
  password: '',
  repeatPassword: ''
})

const clearErrors = () => Object.keys(errors).forEach((key) => delete errors[key])

const reset = () => {
  form.currentPassword = ''
  form.password = ''
  form.repeatPassword = ''
  clearErrors()
}

const handleSubmit = async () => {
  clearErrors()
  try {
    await passwordSchema.validate(form, { abortEarly: false })
  } catch (err) {
    if (err instanceof ValidationError) {
      const inner = err.inner?.length ? err.inner : [err]
      inner.forEach((e) => {
        if (e.path) errors[e.path] = e.message
      })
    }
    return
  }

  saving.value = true
  try {
    await props.save({ password: form.password, repeatPassword: form.repeatPassword })
    reset() // limpa os campos só em sucesso real
  } catch {
    // o pai já exibiu o toast de erro
  } finally {
    saving.value = false
  }
}
</script>
